<script lang="ts">
  import type { Target } from '@shared/types';
  import { Icon, type IconNames } from '@shared/ui/icon';
  import { is } from '@shared/utils';

  export let icon: IconNames | undefined = undefined;
  export let label: string | undefined = undefined;
  export let onDelete: (() => void) | undefined = undefined;
  export let href: string | undefined = undefined;
  export let target: Target = '_self';

  export let variant: 'primary' | 'secondary' = 'primary';
  export let size: 'sm' | 'md' | 'lg' = 'sm';

  const styles = {
    sizes: {
      sm: 'text-sm px-2 py-1.5 gap-1',
      md: 'text-base px-2 py-2 gap-1',
      lg: 'text-lg px-2 py-2',
    },
    variant: {
      primary: '',
      secondary: 'rounded-full',
    },
  };
</script>

<svelte:element
  this="{href ? 'a' : 'div'}"
  {href}
  target="{href ? target : null}"
  class="
    bg-default-100 text-default-900 dark:bg-dark-50 flex items-center transition-colors dark:text-white
    {is(!!href, 'hover:bg-default-900 dark:hover:bg-dark-900 dark:hover:text-dark-50 cursor-pointer hover:text-white')}
    {styles.sizes[size]}
    {styles.variant[variant]}
  "
>
  {#if icon}
    <Icon name="{icon}" width="{24}" height="{24}" />
  {/if}
  {#if $$slots.default || label}
    <slot>
      <p class="px-1">
        {label}
      </p>
    </slot>
  {/if}
  {#if onDelete}
    <button class="h-full pl-0.5" type="button" on:click|stopPropagation="{onDelete}">
      <Icon name="close" classes="fill-default-600 hover:fill-default-900 dark:fill-dark-700 dark:hover:fill-white" />
    </button>
  {/if}
</svelte:element>
